import { AgentumReportWithRelations } from '@api/generated'
import { BaseReportFields } from '@modules/missions/keaz/types'
import { formatDate } from '@modules/missions/keaz/utils/date'

interface TasksTableCellExecutionDateProps {
  task: AgentumReportWithRelations
}

export function TasksTableCellExecutionDate({ task }: TasksTableCellExecutionDateProps) {
  if (!task[BaseReportFields.date]) {
    return <></>
  }

  return <>{formatDate(task[BaseReportFields.date] as number)}</>
}
